import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { delay } from "./Utils";
import { createToast } from "./Toast";

const CreateSubmission = (modal) => {
  // get the submission form
  const form = document.getElementById("create_submission_form");
  if (form) {
    // sending data ui elements
    const spinner = form.querySelector("button[type=submit] svg");
    const spinnerText = form.querySelector("button[type=submit] span");

    // onSubmit
    form.addEventListener("submit", (ev) => {
      ev.preventDefault();

      // update sending data ui status
      spinner.classList.remove("hidden!");
      spinnerText.textContent = "Saving...";

      // build form data
      const data = new FormData(form);
      data.append("action", "create_submission");

      // console.log([...data]);
      // return;

      // perform POST request
      sendAjaxDataToWP(data)
        .then((result) => {
          if (result) {
            //console.log("Data received from server:", result);
          }

          delay(1000).then(() => {
            // reset ui
            spinner.classList.add("hidden!");
            spinnerText.textContent = "Save";

            createToast({
              type: "success",
              message: result.message,
              duration: 1000,
              url: "/submissions",
            });
          });
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);

          // reset ui
          spinner.classList.add("hidden!");
          spinnerText.textContent = "Save";

          // display success feedback
          createToast({
            type: "error",
            message: "System Error!",
            duration: 1000,
          });
        });
    });
  }
};

export { CreateSubmission };
